import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import Container from '../Shared/Container';
import { BREAKPOINTS, COLORS_BASE } from '../../utils/consts';
import FooterContactCard from './FooterContactCard';
import { faMapPin, faGlobe, faEnvelope, faUserFriends } from '@fortawesome/free-solid-svg-icons';

function Footer() {
    return (
            <FooterStyle>
                <ContactInfoStyle>
                    <FooterContactCard faIcon={faMapPin} header="Office" text="Sekhametsi Building Second Floor 
                        Private Bag A92 
                        Maseru 100 
                        Lesotho "/>
                    <FooterContactCard faIcon={faGlobe} header="Website" text="doe.gov.ls"/>
                    <FooterContactCard faIcon={faEnvelope} header="Email" text="doe.info@gov.ls"/>
                    <FooterContactCard faIcon={faUserFriends} header="Facebook" text="facebook.com/LesDofE"/>
                </ContactInfoStyle>
                <DevelopedByStyle>
                    <div>This platform has been developed with support from Renewable Lesotho, a collaboration between the Government of Lesotho, the European Union and development partners.</div>
                    <LogosContainerStyle>
                        <GlobalGatewayStyle src='/logos/GG_logo-BLUE.png' alt="Global gateway Logo" />
                        <FlagEuStyle>
                            <LesothoFlagStyle src='/logos/Flag-of-Lesotho.png' alt="Global gateway Logo" />
                            <CoFundedEUStyle src='/logos/EN_co_fundedvertical_RGB_POS.png' alt="Global gateway Logo" />
                        </FlagEuStyle>
                        <div>
                        <GetTransformStyle src='/logos/getTransform.png' alt="Get Transform logo" />
                        <GetInvestStyle src='/logos/getInvest.png' alt="Get Invest logo" />
                        </div>
                        <div>
                            <CoFundedText>GET.transform and GET.invest are co-funded by</CoFundedText>
                            <CoFundedAllStyle src='/logos/coFunders.png' alt="Logos of all co-financiers of get transform and get invest" />
                        </div>
                    </LogosContainerStyle>
                </DevelopedByStyle>
                <AllRightsStyle>
                    <u>Terms of service</u>
                    <p>{`© ${new Date().getFullYear()} DoE All rights reserved`}</p>
                    <u>Accreditation</u>
                </AllRightsStyle>
            </FooterStyle>
    )
}


const FooterStyle = styled.footer`
    width: 100%;
    overflow-x: hidden;
`

const DevelopedByStyle = styled.div`
    margin: 100px 100px;

    @media (max-width: ${BREAKPOINTS.MOBILE}) {
      margin: 40px 16px;
    }
`

const LogosContainerStyle = styled.div`
    width: 100%;
    margin: 100px auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
        gap: 16px;

        @media (max-width: ${BREAKPOINTS.MOBILE}) {
            margin: 40px auto;
            align-items: center;
        }
`

const ContactInfoStyle = styled.div`
        padding: 100px 24px;
    display: flex;
    background-color: ${COLORS_BASE.GREEN.MAIN};
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    gap: 20px;

        @media (max-width: ${BREAKPOINTS.MOBILE}) {
            padding: 40px 16px;
            justify-content: flex-start;
            gap: 10px;
        }
`

const AllRightsStyle = styled.div`
    background-color: ${COLORS_BASE.GREYS.DARKER};
    color: white;
    padding: 40px 20px;
    display: flex;
    justify-content: space-between;
    gap: 12px;

    @media (max-width: ${BREAKPOINTS.MOBILE}) {
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
    }
`

const FlagEuStyle = styled.div`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: center;
`

const GlobalGatewayStyle = styled.img`
    width: 10rem;
    object-fit: contain;
    padding: 1rem;
`
const LesothoFlagStyle = styled.img`
    width: 4rem;
    object-fit: contain;
    padding-top: 2rem;
`

const CoFundedEUStyle = styled.img`
    width: 5rem;
    object-fit: contain;
    padding-left: 0.5rem;
    padding-top: 1.5rem;
`

const CoFundedAllStyle = styled.img`
    height: auto;
    width: min(100%, 540px);
    object-fit: contain;
    padding-left: 0.5rem;
    padding-top: 1.5rem;
`

const GetTransformStyle = styled.img`
    height: 4rem;
    object-fit: contain;
    padding: 1rem 1rem 0rem 2rem;
`

const GetInvestStyle = styled.img`
    height: 4rem;
    object-fit: contain;
    padding: 1rem 1rem 0rem 0rem;
`

const CoFundedText = styled.div`
    font-weight: bold;
    font-size: 0.7rem;

    @media (max-width: ${BREAKPOINTS.MOBILE}) {
      text-align: center;
    }
`

export default Footer;